import axios from '@/services/axios.js'
import type { UserLabourApp } from '@/types/user-labour-app'

export async function getUserAvailableApps(): Promise<UserLabourApp[]> {
  const response = await axios.get('/api/user/labour-apps')
  return response.data?.apps
}

interface AppSettingsPayload {
  id: number
  [key: string]: unknown
}

export async function updateUserAppSettings(
  app: AppSettingsPayload
): Promise<{ message: string }> {
  const response = await axios.post(`/api/user/labour-apps/${app.id}`, app)
  return response.data
}
